import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Priority, PriorityOption } from '@lib/api/models/priorities';
import { Provider } from '@lib/api/models/provider';
import { ZoneOption, Zone } from '@lib/api/models/zone';

export interface RegionOption {
    id: string,
    name: string,
    zones: ZoneOption[],
    priorities: PriorityOption[],
}

export interface Region {
    id: string;
    name: string;
    reference: string;
    status: boolean;
    priorities: Priority[];
    providers: Provider[];
    zones: Zone[];
    created_at: string;
    updated_at: string;
}

export interface RegionSingleResponse {
    data: Region;
}

export interface RegionsOptionsResponse {
    data: RegionOption[];
}

export interface StoreRegionRequest {
    name: string;
    reference: string;
    status: boolean;
}

export function createRegionFormGroup(region?: Region) {
    return new FormGroup({
        reference: new FormControl<string>(region?.reference ?? '', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50)
        ]),
        name: new FormControl<string>(region?.name ?? '', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(255)
        ])
    });
}
